import { Component, OnInit } from '@angular/core';
import { applicationContentConfig } from '../../configs/config-internal-content';
import { session } from '../../common/session/session';
import { BrandService } from '../../common/services/brand-service';
import { CollapsibleBoxComponent } from 'ui-common-components-angular';
import { CollapsibleBox } from '../../shared/models/ui-component-interfaces';
@Component({
    selector: 'olb-app-call-us',
    templateUrl: './call-us.component.html',
    styleUrls: ['./call-us.component.scss'],
    imports: [CollapsibleBoxComponent]
})
export class CallUsComponent implements OnInit {
  callUsBox!: CollapsibleBox;
  segment!: string;
  constructor(private brandService: BrandService) {}

  ngOnInit(): void {
    this.segment = session.segment;
    this.callUsBox = this.getCallUsDetails(
      this.brandService.isCahoot(),
      this.brandService.isSbbi(),
      this.segment
    );
  }

  // Quick link data retrieved from applicationContentConfig
  getCallUsDetails(
    isCahoot: boolean,
    isSBBI: boolean,
    segment?: string
  ): CollapsibleBox {
    let callUsData: CollapsibleBox;
    if (isSBBI) {
      callUsData = applicationContentConfig.CALL_US_BOX_SBBI;
    } else if (isCahoot) {
      callUsData = applicationContentConfig.CALL_US_BOX_CAHOOT;
    } else {
      callUsData = applicationContentConfig.CALL_US_BOX_RETAIL;
      switch (segment) {
        case 'private': {
          callUsData.content[0].details[0] =
            applicationContentConfig.CALL_US_MANAGING_ACCOUNT_PRIVATE;
          break;
        }
        case 'select': {
          callUsData.content[0].details[0] =
            applicationContentConfig.CALL_US_MANAGING_ACCOUNT_SELECT;
          break;
        }
      }
    }

    return callUsData;
  }
}
